<template>
  <div class="dispute-resolution__modal">
    <Modal
      :size="activeStep === 'bulk_update_message' ? 'small' : 'medium'"
      :active="true"
      :close-on-click-outside="false"
      @onClose="onClose()">
      <template #header>
        <p>{{ resolutionModalSteps[activeStep].title }}</p>
      </template>
      <div slot="content">
        <loading
          :active.sync="loader"
          :can-cancel="false"
          :is-full-page="true"
          color="#0573ab" />
        <div v-if="activeStep === 'case_details_form'">
          <dispute-case-details-form
            ref="updateCaseDetailsForm"
            v-bind="$props"
            :updated-data="updatedCaseDetails"
            :is-s-l-a-missed="isSLAMissed"
            :reason-for-delay-options="reasonForDelayOptions"
            @onBulkUpdateError="onBulkUpdateError"
            @onSubmit="onSubmitCaseDetailsForm"
            @updateDisputeStage="updateDisputeStage"
            @updateDisputeStatus="updateDisputeStatus"
            @invoiceApiLoading="invoiceApiLoading = $event"
            v-on="$listeners" />
        </div>
        <div v-else-if="activeStep === 'voice_form'">
          <dispute-with-voice-form
            ref="disputeWithVoiceForm"
            v-bind="$props"
            :voice-dispute-data="disputeWithVoiceData"
            @onSubmit="onSubmitVoiceForm"
            @updateVoiceData="updateVoiceData" />
        </div>
        <div v-else-if="activeStep === 'bulk_update_message'">
          <div class="dispute-resolution__modal__warning">
            <icon size="24" name="exclamation-circle" />
            <div class="dispute-resolution__modal__warning__heading">
              <p class="dispute-resolution__modal__warning__heading-p">
                {{ bulkAlertTitile }}
              </p>
              <span class="dispute-resolution__modal__warning__content">
                {{ bulkAlertMessage }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="activeStep === 'case_details_form'"
        slot="footer"
        class="dispute-resolution__modal__footer modal__footer">
        <div>
          <Button
            :label="resolutionButtonValues[1]"
            appearance="tertiary"
            @onClick="onClose()" />
          <Button
            v-if="showUpdateDwvCta"
            label="Update DwV"
            appearance="primary"
            class="dispute-resolution__modal__footer__primary-btn"
            @onClick="onResolutionFormSubmitClick" />
          <Button
            v-else
            :label="resolutionButtonValues[0]"
            :disabled="disableSubmit"
            appearance="primary"
            class="dispute-resolution__modal__footer__primary-btn"
            @onClick="onResolutionFormSubmitClick" />
        </div>
      </div>
      <div
        v-else-if="activeStep === 'voice_form'"
        slot="footer"
        class="modal__footer">
        <span @click="onBackClick">
          <icon
            name="arrow-left"
            class="dispute-resolution__modal__footer__back-btn" />
        </span>
        <span>
          <Button label="Close" appearance="tertiary" @onClick="onClose()" />
          <Button
            :label="resolutionButtonValues[0]"
            appearance="primary"
            class="dispute-resolution__modal__footer__primary-btn"
            @onClick="onVoiceFormSubmitClick" />
        </span>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  resolutionModalSteps,
  statusCodesToEnableDwV,
} from "@/config/disputeUpdateModalConstant.js";
import DisputeCaseDetailsForm from "@/components/DisputeUpdateModals/DisputeCaseDetailsModal/DisputeCaseDetailsForm.vue";
import DisputeWithVoiceForm from "@/components/DisputeUpdateModals/DisputeWithVoiceModal/DisputeWithVoiceForm.vue";
// Loading component
import Loading from "vue-loading-overlay";
import { showToast } from "@/components/common/Toast";

export default {
  name: "DisputeCaseDetailsModal",
  components: {
    DisputeCaseDetailsForm,
    DisputeWithVoiceForm,
    Loading,
  },
  props: {
    disputesConstants: {
      type: Object,
      required: true,
    },
    disputeLookupFields: {
      type: Object,
      required: true,
    },
    disputeChargecodeFields: {
      type: Object,
      required: true,
    },
    caseDetails: {
      type: Object,
      required: true,
    },
    formDisabledList: {
      type: Array,
      default: () => [],
    },
    formMandatoryList: {
      type: Array,
      default: () => [],
    },
    resolutionStatusList: {
      type: Array,
      required: true,
    },
    resolutionStagesList: {
      type: Array,
      required: true,
    },
    resolutionButtonValues: {
      type: Array,
      required: true,
    },
    selectedRowsLength: {
      type: Number,
      default: 0,
    },
    bulkData: {
      type: Array,
      default() {
        return [];
      },
    },
    nextStatusDropDownList: {
      type: Array,
      default: () => {},
    },
    resolutionRulesLoading: {
      type: Boolean,
      default: false,
    },
    disputeModalLoading: {
      type: Boolean,
      default: false,
    },
    isSLAMissed: {
      type: Boolean,
    },
    reasonForDelayOptions: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      resolutionModalSteps,
      activeStep: "case_details_form",
      updatedCaseDetails: {},
      disputeWithVoiceData: {},
      disputeStage: null,
      disputeStatus: null,
      bulkAlertTitile:
        "Please fulfill the following condition for Voice bulk update -",
      bulkAlertMessage:
        "Contact person should be same for selected disputes to do bulk voice update.",
      fetchVoiceDisputeCalled: false,
      isExternalComment: false,
      invoiceApiLoading: false,
    };
  },
  computed: {
    showUpdateDwvCta() {
      return (
        (this.disputeStage === "Reject with voice" &&
          this.caseDetails.disputeStage !== "Reject with voice") ||
        (this.disputeStage === "Reject" &&
          this.disputeStatus &&
          statusCodesToEnableDwV.indexOf(this.disputeStatus) > -1 &&
          this.caseDetails.disputeStage !== "Reject")
      );
    },
    disableSubmit() {
      return false;
    },
    loader() {
      return (
        this.resolutionRulesLoading ||
        this.disputeModalLoading ||
        this.invoiceApiLoading
      );
    },
  },
  watch: {
    showUpdateDwvCta() {
      if (
        !this.fetchVoiceDisputeCalled &&
        this.showUpdateDwvCta &&
        (!this.selectedRowsLength || this.selectedRowsLength === 1)
      ) {
        this.fetchVoiceDisputeCalled = true;
        this.$emit(
          "fetchVoiceDisputes",
          this.caseDetails.ohpDisputeId,
          (data) => {
            const sortedData = (data || []).sort(
              (a, b) => new Date(b.changedTs) - new Date(a.changedTs)
            );
            this.disputeWithVoiceData = sortedData.length
              ? {
                  ...sortedData[0],
                  voiceOutcome: null,
                  isAttemptSuccessful: null,
                  isCustomerAligned: null,
                }
              : {};
          }
        );
      }
    },
  },
  methods: {
    updateDisputeStage(stage) {
      this.disputeStage = stage;
    },
    updateDisputeStatus(status) {
      this.disputeStatus = status;
    },
    onBackClick() {
      this.$refs.disputeWithVoiceForm.onBackClicked();
      this.activeStep = "case_details_form";
      document.getElementsByClassName("modal__content")[0].scrollTop = 0;
    },
    onClose() {
      this.$emit("onModalClose");
    },
    onResolutionFormSubmitClick() {
      this.$refs.updateCaseDetailsForm.onSubmitCalled();
    },
    onVoiceFormSubmitClick() {
      this.$refs.disputeWithVoiceForm.onSubmitCalled();
    },
    getCommentText(comments) {
      if (comments) {
        const commentHTML = document.createElement("p");
        commentHTML.innerHTML = comments;
        return commentHTML.textContent.trim();
      }
      return undefined;
    },
    saveCommentsCallback(comments, successResponse) {
      const commentsText = this.getCommentText(comments);
      if (commentsText) {
        if (this.selectedRowsLength > 1) {
          this.$emit(
            "saveBulkComments",
            {
              ohpDisputeIds: successResponse,
              commentText: commentsText,
              commentHtml: comments,
            },
            { isExternal: this.isExternalComment }
          );
          this.$emit("onModalClose");
        } else {
          this.$emit(
            "saveComments",
            { commentText: commentsText, commentHtml: comments },
            {
              ohpDisputeId: this.caseDetails.ohpDisputeId,
              hideLoader: true,
              isExternal: this.isExternalComment,
            }
          );
        }
      }
    },
    onBulkUpdateError(errorMessage) {
      showToast("error", `${errorMessage}`);
    },
    onSubmitCaseDetailsForm(formState, payload) {
      this.updatedCaseDetails = {
        ...this.updatedCaseDetails,
        ...payload,
      };
      this.isExternalComment = formState.isExternalComment;
      let bulkCommentInvoiceObj = {};
      if (this.showUpdateDwvCta) {
        if (this.selectedRowsLength) {
          const differentDisputeContact = this.bulkData.filter(
            (item) =>
              item.contactPerson !== this.bulkData[0].contactPerson ||
              item.contactEmail !== this.bulkData[0].contactEmail
          );
          if (!differentDisputeContact.length) {
            this.activeStep = "voice_form";
            document.getElementsByClassName("modal__content")[0].scrollTop = 0;
          } else {
            this.activeStep = "bulk_update_message";
          }
        } else {
          this.activeStep = "voice_form";
          document.getElementsByClassName("modal__content")[0].scrollTop = 0;
        }
      } else {
        if (this.selectedRowsLength > 1) {
          const bulkDisputePayload = this.bulkData.map((item) => ({
            ohpDisputeId: item.ohpDisputeId,
            ...this.updatedCaseDetails,
            noteDescription: this.getCommentText(
              this.updatedCaseDetails.noteDescription
            ),
            invoiceNumber: item.invoiceNumber,
          }));
          this.bulkData.map((item) => {
            bulkCommentInvoiceObj = {
              ...bulkCommentInvoiceObj,
              [item.invoiceNumber]: {
                ohpDisputeId: item.ohpDisputeId,
                noteDescription: this.getCommentText(
                  this.updatedCaseDetails.noteDescription
                ),
                commentText: this.getCommentText(
                  this.updatedCaseDetails.noteDescription
                ),
                commentHtml: this.updatedCaseDetails.noteDescription,
                isExternal: this.isExternalComment || false,
              },
            };
          });
          const bulkDisputeValidatePayload = this.bulkData.map((item) => ({
            ohpDisputeId: item.ohpDisputeId,
            countryCode: item.countryCode,
            createdTs: item.createdTs,
            lastDisputedTs: item.lastDisputedTs,
            closedTs: item.closedTs,
            resolutionDelayReason:
              this.updatedCaseDetails.resolutionDelayReason,
            isDwV: item.isDwV || false,
          }));
          this.$emit(
            "updateResolutionDisputeModal",
            {
              isBulkUpdateCreditNote: formState?.isBulkUpdateCreditNote,
              data: bulkDisputePayload,
              commentsData: bulkCommentInvoiceObj,
            },
            true,
            () => {},
            bulkDisputeValidatePayload
          );
        } else {
          this.$emit(
            "updateResolutionDisputeModal",
            {
              ...this.updatedCaseDetails,
              noteDescription: this.getCommentText(
                this.updatedCaseDetails.noteDescription
              ),
              isCreditNoteManual:
                formState?.isCreditNoteManual == true ? true : false,
            },
            false,
            () => {
              this.saveCommentsCallback(
                this.updatedCaseDetails.noteDescription
              );
            }
          );
        }
      }
    },
    updateVoiceData(formState) {
      this.disputeWithVoiceData = {
        ...this.disputeWithVoiceData,
        ...formState,
      };
    },
    onSubmitVoiceForm(payload) {
      let bulkCommentInvoiceObj = {};
      this.updateVoiceData(payload);
      if (this.selectedRowsLength) {
        const bulkDisputePayload = this.bulkData.map((item) => ({
          ohpDisputeId: item.ohpDisputeId,
          ...this.updatedCaseDetails,
          noteDescription: this.getCommentText(
            this.updatedCaseDetails.noteDescription
          ),
          invoiceNumber: item.invoiceNumber,
        }));
        this.bulkData.map((item) => {
          bulkCommentInvoiceObj = {
            ...bulkCommentInvoiceObj,
            [item.invoiceNumber]: {
              ohpDisputeId: item.ohpDisputeId,
              noteDescription: this.getCommentText(
                this.updatedCaseDetails.noteDescription
              ),
              commentText: this.getCommentText(
                this.updatedCaseDetails.noteDescription
              ),
              commentHtml: this.updatedCaseDetails.noteDescription,
              isExternal: this.isExternalComment || false,
            },
          };
        });
        const bulkDisputeValidatePayload = this.bulkData.map((item) => ({
          ohpDisputeId: item.ohpDisputeId,
          countryCode: item.countryCode,
          createdTs: item.createdTs,
          lastDisputedTs: item.lastDisputedTs,
          closedTs: item.closedTs,
          resolutionDelayReason: this.updatedCaseDetails.resolutionDelayReason,
        }));
        this.$emit(
          "updateResolutionDisputeModal",
          {
            data: bulkDisputePayload,
            commentsData: bulkCommentInvoiceObj,
            dwvData: {
              ...this.disputeWithVoiceData,
              ohpDisputeVoiceAgent:
                this?.disputeWithVoiceData?.ohpDisputeVoiceAgent?.apmId,
            },
          },
          true,
          () => {
            this.$emit("onModalClose");
          },
          bulkDisputeValidatePayload
        );
      } else {
        this.$emit(
          "updateResolutionDisputeModal",
          {
            ...this.updatedCaseDetails,
            noteDescription: this.getCommentText(
              this.updatedCaseDetails.noteDescription
            ),
          },
          false,
          () => {
            this.saveCommentsCallback(this.updatedCaseDetails.noteDescription);
            this.$emit("createVoiceDisputes", {
              ...this.disputeWithVoiceData,
              ohpDisputeVoiceAgent:
                this?.disputeWithVoiceData?.ohpDisputeVoiceAgent?.apmId,
            });
          }
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.dispute-resolution__modal {
  &__footer {
    justify-content: flex-end !important;
    &__primary-btn {
      margin-left: 16px;
    }
    &__back-btn {
      font-size: 32px;
    }
  }
  .modal--medium {
    width: 948px;
    height: calc(100vh - 65px);
  }
  .modal--small {
    height: 380px;
  }
  .modal__footer {
    z-index: 1;
  }
  & .p-page__modal__window__content {
    padding-top: 0;
  }
  &__warning {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    &__heading {
      margin-left: 1rem;
      &-p {
        margin-bottom: 1rem;
      }
    }
    &__content {
      margin-left: 1rem;
    }
  }
}
</style>
